import { useQuery } from "@tanstack/react-query";
import BinApiService from "src/api/BinApiService";
import { binQueryKeys, getUserTimezoneOffset } from "src/components/BinDetails";

export const useBinStateFromAzure = (params: { binId: number, userTimeZoneOffset?: number
},
    queryOptions: {
        enabled?: boolean,
        staleTime?: number,
        refetchInterval?: number,
    }
) => {

    return useQuery(binQueryKeys.stateFromAzure(params.binId!), async (q) => {
        const binDTO = await BinApiService.getBinDetailFromAzure(params.binId, params.userTimeZoneOffset ?? getUserTimezoneOffset(), q.signal);
        if (binDTO == null) {
            throw new Error("Bin State from device is empty");
        }
        return binDTO;
    }, {
        enabled: queryOptions.enabled,
        staleTime: queryOptions.refetchInterval,
        refetchInterval: queryOptions.refetchInterval,
        onError: (err) => console.error("problem getting binState from Azure", err),
    });
};